import React from 'react';

interface FormInputProps {
  id: string;
  label: string;
  type?: 'text' | 'email' | 'tel' | 'date';
  placeholder?: string;
  error?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  maxLength?: number;
}

export function FormInput({
  id,
  label,
  type = 'text',
  placeholder,
  error,
  value,
  onChange,
  onBlur,
  maxLength,
}: FormInputProps) {
  return (
    <div>
      <label htmlFor={id} className="mb-2 block text-[14px] font-normal leading-[170%] text-[#3B3B3B]">
        {label}
      </label>
      <input
        type={type}
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        maxLength={maxLength}
        style={{
          borderWidth: '1.5px',
          borderStyle: 'solid',
          borderColor: error ? '#EF4444' : '#E5E7EB',
          padding: '12px 16px',
        }}
        className={`w-full rounded-lg bg-white text-[16px] leading-[170%] text-[#3B3B3B] placeholder:text-[#3B3B3B]/40 focus:outline-none focus:ring-2 focus:ring-[#7CF1C7] focus:border-transparent`}
        placeholder={placeholder}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
